import Header from "../src/components/header/header";
import ChatBot from "../src/screens/bot/bot";
import { useEffect } from "react";
import PropTypes from "prop-types";
import useInitialConfigStore from "./storeModules/useInitialConfigStore";
import GoogleTagManager from "./components/gtm/gtm";
import useConsorcioStore from "./storeModules/useConsorcioStore";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { ErrorBoundary } from "@datadog/browser-rum-react";
import { useLocationStore } from "./storeModules/useLocationStore";
import { resolveReferralCodeFromUrl } from "./utils/updateReferralCodeFromUrl";
import { sanitizeInput } from "./utils/sanitize";

function App(props) {
  const {
    campanhaId,
    compraId,
    title,
    description,
    desconto,
    allowIndexing,
    gtmId,
    siteDomain,
    empresaId,
    shouldUseCoupon,
    copyMessage,
    theme,
    tipoTabela,
    brand,
    navBar,
    tipoPlano,
    botType,
    linkWhatsApp,
    isApp,
    bannerSrc,
    seguro,
    button_color_text,
    button_color_background,
  } = props;

  const { setInitialConfigStore } = useInitialConfigStore();
  const { setConsorcioStore } = useConsorcioStore();
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const idc = sanitizeInput(urlParams.get("idc"));

  // const isApp = window.location.href.includes("app");
  const canonicalUrl = window.location.href;

  const setThemeBackGroundColor = (color) => {
    const appBody = document.querySelector("body");

    if (appBody) {
      appBody.style.backgroundColor = color;
    }
  };

  useEffect(() => {
    setInitialConfigStore(campanhaId, "campanhaId");
    setInitialConfigStore(compraId, "compraId");
    setInitialConfigStore(empresaId, "empresaId");
    setInitialConfigStore(desconto, "desconto");
    setInitialConfigStore(tipoTabela, "tipoTabela");
    setInitialConfigStore(brand, "brand");
    setInitialConfigStore(navBar, "navBar");
    setInitialConfigStore(siteDomain, "siteDomain");
    setInitialConfigStore(gtmId, "gtmId");
    setInitialConfigStore(bannerSrc, "bannerSrc");
    setConsorcioStore(tipoPlano, "tipoPlano");
    setInitialConfigStore(botType, "botType");
    setInitialConfigStore(linkWhatsApp, "linkWhatsApp");
    setInitialConfigStore(copyMessage, "initialCopys");
    setInitialConfigStore(theme, "theme");
    setInitialConfigStore(isApp, "isApp");
    setInitialConfigStore(seguro, "seguro");
    setInitialConfigStore(button_color_text, "button_color_text");
    setInitialConfigStore(button_color_background, "button_color_background");

    if (idc) {
      setInitialConfigStore(idc, "campanhaId");
    }

    if (shouldUseCoupon) {
      setInitialConfigStore(shouldUseCoupon, "shouldUseCoupon");
    }

    setThemeBackGroundColor(theme.backgroundColor);

    try {
      const rawLocation = localStorage.getItem("userLocation");
      if (rawLocation) {
        const parsed = JSON.parse(rawLocation);
        const now = Date.now();

        if (!parsed._expires || now < parsed._expires) {
          useLocationStore.getState().setLocation(parsed.data);
        }
      }
    } catch (err) {
      console.warn("Erro ao ler userLocation do localStorage:", err);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const referralcode = resolveReferralCodeFromUrl(location.search);
    setInitialConfigStore(referralcode, "referralcode");
  }, [location.search, setInitialConfigStore]);

  return (
    <ErrorBoundary>
      <div className="App">
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <link rel="canonical" href={canonicalUrl} />
          <meta name="robots" content={allowIndexing} />
          <meta itemprop="url" content={canonicalUrl} />

          <meta itemprop="name" content={title} />
          <meta itemprop="url" content={siteDomain} />
          <meta
            itemprop="image"
            content={`https://chatbot-cdn.mycon.com.br/custom/opengraph/${empresaId}.jpg`}
          />

          <meta property="og:locale" content="pt_BR" />
          <meta property="og:title" content={title} />
          <meta property="og:site_name" content="myconsorcio" />
          <meta property="og:type" content="article" />
          <meta property="og:description" content={description} />
          <meta property="og:url" content={siteDomain} />
          <meta
            property="og:image"
            content={`https://chatbot-cdn.mycon.com.br/custom/opengraph/${empresaId}.jpg`}
          />
        </Helmet>
        <GoogleTagManager
          gtmId={gtmId}
          brand={brand}
          siteDomain={siteDomain}
          tipoOrigem="bot"
        />
        {!isApp && <Header />}
        <ChatBot bannerSrc={bannerSrc} />
      </div>
    </ErrorBoundary>
  );
}

App.propTypes = {
  campanhaId: PropTypes.number,
  compraId: PropTypes.number,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  desconto: PropTypes.bool,
  allowIndexing: PropTypes.string,
  gtmId: PropTypes.string,
  siteDomain: PropTypes.string.isRequired,
  empresaId: PropTypes.number,
  shouldUseCoupon: PropTypes.bool,
  copyMessage: PropTypes.array,
  theme: PropTypes.shape({
    backgroundColor: PropTypes.string,
  }),
  tipoTabela: PropTypes.string,
  brand: PropTypes.string,
  navBar: PropTypes.bool,
  tipoPlano: PropTypes.string,
  botType: PropTypes.string,
  linkWhatsApp: PropTypes.string,
  isApp: PropTypes.bool,
  bannerSrc: PropTypes.string,
  seguro: PropTypes.bool,
  button_color_text: PropTypes.string,
  button_color_background: PropTypes.string,
};

export default App;
